import NpsPage from "@/projects/FinEaseUser/pages/Nps/NpsPage";
import finEaseUserNavigationRoutes from "./navigationRoutes";
import NpsUserList from "@/projects/FinEaseHomeAndAdmin/pages/AdminFinEase/Nps/NpsUserList";

// Auth routes that require authentication
const authRoutes = [
  {
    path: finEaseUserNavigationRoutes.NPS_OVERVIEW,
    element: NpsPage,
    name: "Nps Overview",
  },
  {
    path: finEaseUserNavigationRoutes.NPS_USER_LIST,
    element: NpsUserList,
    name: "Nps User List",
  },
];

// Main routes configuration
const routes = [
  {
    type: "auth",
    routes: authRoutes,
  },
];

export default routes;
